const resources = {
    nameError: 'Veuillez remplir ce champ.',
    name: 'Nom',
    edit: 'Modifier',
    firstNameLabel: 'Prénom',
    lastNameLabel: 'Nom de famille',
    cancel: 'Annuler',
    update: 'Mise à jour'
};

module.exports = function getResource(label) {
    return resources[label];
};
